// vue2-smooth-scroll 대체: href="#id" 앵커 클릭 시 해당 요소로 부드럽게 스크롤
export default {
    install(app) {
        app.directive('smooth-scroll', {
            mounted(el) {
                el.addEventListener('click', (e) => {
                    const hash = el.getAttribute('href')
                    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return
                    const target = document.querySelector(hash)
                    if (!target) return
                    e.preventDefault()
                    target.scrollIntoView({ behavior: 'smooth' })
                })
            }
        })
    }
}
